const CACHE_PREFIX = 'crm_active_user_package_v1_';
const TTL_MS = 24 * 60 * 60 * 1000;

export function activeUserPackageCacheKey(clientId: string | number): string {
  return `${CACHE_PREFIX}${clientId}`;
}

export function readActiveUserPackageCache(clientId: string | number): any | null {
  try {
    const raw = localStorage.getItem(activeUserPackageCacheKey(clientId));
    if (!raw) {
      return null;
    }
    const parsed = JSON.parse(raw);
    if (!parsed?.fetchedAt || parsed.response == null) {
      return null;
    }
    if (Date.now() - parsed.fetchedAt > TTL_MS) {
      localStorage.removeItem(activeUserPackageCacheKey(clientId));
      return null;
    }
    return parsed.response;
  } catch {
    return null;
  }
}

export function writeActiveUserPackageCache(clientId: string | number, response: any): void {
  try {
    localStorage.setItem(
      activeUserPackageCacheKey(clientId),
      JSON.stringify({
        fetchedAt: Date.now(),
        response,
      })
    );
  } catch {
    /* localStorage full or disabled */
  }
}

export function clearActiveUserPackageCache(clientId?: string | number | null): void {
  if (clientId != null && clientId !== '') {
    localStorage.removeItem(activeUserPackageCacheKey(clientId));
    return;
  }

  const keysToRemove: string[] = [];
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key?.startsWith(CACHE_PREFIX)) {
      keysToRemove.push(key);
    }
  }
  keysToRemove.forEach((key) => localStorage.removeItem(key));
}
